/* Savia shop: client-side faceted filtering over all rendered products. */
(function () {
  var grid = document.getElementById('sv-grid');
  if (!grid) return;
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.sv-shop__card'));
  var countEl = document.getElementById('sv-count');
  var emptyEl = document.getElementById('sv-empty');
  var sortEl = document.getElementById('sv-sort');
  var clearBtn = document.querySelector('.sv-shop__clear');
  var sidebar = document.getElementById('sv-filters');
  var toggle = document.querySelector('.sv-shop__filter-toggle');

  // Build dynamic Size and Color facets from the rendered cards.
  var sizeSet = [], colorSet = [];
  cards.forEach(function (c) {
    (c.dataset.sizes || '').split('|').forEach(function (s) { if (s && sizeSet.indexOf(s) < 0) sizeSet.push(s); });
    (c.dataset.colors || '').split('|').forEach(function (s) { if (s && colorSet.indexOf(s) < 0) colorSet.push(s); });
  });
  var sizeOrder = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', 'One size'];
  sizeSet.sort(function (a, b) { return sizeOrder.indexOf(a) - sizeOrder.indexOf(b); });

  var sizeWrap = document.querySelector('[data-group="size"]');
  sizeSet.forEach(function (s) {
    var l = document.createElement('label');
    l.className = 'sv-facet__pill';
    l.innerHTML = '<input type="checkbox" data-filter="size" value="' + s + '"><span>' + s + '</span>';
    sizeWrap.appendChild(l);
  });
  var colorWrap = document.querySelector('[data-group="color"]');
  colorSet.sort();
  colorSet.forEach(function (s) {
    var l = document.createElement('label');
    l.className = 'sv-facet__opt';
    l.innerHTML = '<input type="checkbox" data-filter="color" value="' + s.toLowerCase() + '"><span>' + s.replace(/\b\w/g, function (m) { return m.toUpperCase(); }) + '</span>';
    colorWrap.appendChild(l);
  });

  function selected(name) {
    return Array.prototype.slice
      .call(document.querySelectorAll('[data-filter="' + name + '"]:checked'))
      .map(function (i) { return i.value; });
  }

  function apply() {
    var eco = selected('eco'), type = selected('type'),
        size = selected('size'), color = selected('color');
    var price = (document.querySelector('[data-filter="price"]:checked') || {}).value || 'any';
    var pr = price === 'any' ? null : price.split('-').map(Number);
    var shown = 0;

    cards.forEach(function (c) {
      var ok = true;
      if (eco.length && eco.indexOf(c.dataset.eco) < 0) ok = false;
      if (ok && type.length && type.indexOf(c.dataset.type) < 0) ok = false;
      if (ok && size.length) {
        var cs = (c.dataset.sizes || '').split('|');
        ok = size.some(function (s) { return cs.indexOf(s) >= 0; });
      }
      if (ok && color.length) {
        var cc = (c.dataset.colors || '').split('|');
        ok = color.some(function (s) { return cc.indexOf(s) >= 0; });
      }
      if (ok && pr) {
        var p = parseFloat(c.dataset.price);
        ok = p >= pr[0] && p <= pr[1];
      }
      c.hidden = !ok;
      if (ok) shown++;
    });

    countEl.textContent = shown + (shown === 1 ? ' product' : ' products');
    emptyEl.hidden = shown !== 0;
    var anyActive = eco.length || type.length || size.length || color.length || price !== 'any';
    if (clearBtn) clearBtn.hidden = !anyActive;
  }

  function sortCards() {
    var mode = sortEl.value;
    var arr = cards.slice();
    arr.sort(function (a, b) {
      if (mode === 'price-asc') return a.dataset.price - b.dataset.price;
      if (mode === 'price-desc') return b.dataset.price - a.dataset.price;
      if (mode === 'az') return a.dataset.title.localeCompare(b.dataset.title);
      return a.dataset.pos - b.dataset.pos;
    });
    arr.forEach(function (c) { grid.appendChild(c); });
  }

  document.querySelectorAll('[data-filter]').forEach(function (i) {
    i.addEventListener('change', apply);
  });
  sortEl.addEventListener('change', sortCards);

  function clearAll() {
    document.querySelectorAll('[data-filter]').forEach(function (i) {
      if (i.type === 'checkbox') i.checked = false;
      if (i.type === 'radio') i.checked = i.value === 'any';
    });
    apply();
  }
  if (clearBtn) clearBtn.addEventListener('click', clearAll);
  var emptyClear = document.getElementById('sv-empty-clear');
  if (emptyClear) emptyClear.addEventListener('click', clearAll);

  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = sidebar.classList.toggle('sv-shop__sidebar--open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  apply();
})();
